import { type ReactElement } from 'react';
import BaseDatePicker from '@creditflowresearch/uilib/Picker/BaseDatePicker';
import { MONTH_DAY_YEAR_FORMAT } from '@dealroadshow/uikit-date-time/dateFormats';
import Flex from '@creditflowresearch/uilib/Flex';
import DateInput from '@/creditflowresearch/ui/common/components/DatePicker/DateInput';
import DatePickerHeader from '@/creditflowresearch/ui/common/components/DatePicker/DatePickerHeader';

import useDateFilter from './useDateFilter';

import styles from '@/creditflowresearch/ui/common/components/DatePicker/styles/dateRangeFilter.module.scss';

const DateFilter = (): ReactElement => {
  const { fromDate, toDate, minDate, maxDate, handleFromChange, handleToChange } = useDateFilter();

  return (
    <Flex align="center" gap={ 8 } flex={ '0' }>
      <BaseDatePicker
        name="dateFrom"
        customInput={ <DateInput name="dateFrom" dataTest="dateFromInput" isClearable={ false } /> }
        renderCustomHeader={ (props) => (
          <DatePickerHeader { ...props } minDate={ minDate } maxDate={ toDate || maxDate } />
        ) }
        dateFormat={ MONTH_DAY_YEAR_FORMAT }
        placeholderText="Select Date"
        selected={ fromDate || minDate }
        isClearable={ false }
        onChange={ handleFromChange }
        minDate={ minDate }
        maxDate={ toDate || maxDate }
        openToDate={ fromDate || minDate }
        popperPlacement="bottom-start"
        usePortal
        dataTest="dateFromPicker"
      />
      <span className={ styles.separator }>-</span>
      <BaseDatePicker
        name="dateTo"
        customInput={ <DateInput name="dateTo" dataTest="dateToInput" isClearable={ false } /> }
        renderCustomHeader={ (props) => (
          <DatePickerHeader { ...props } minDate={ fromDate || minDate } maxDate={ maxDate } />
        ) }
        dateFormat={ MONTH_DAY_YEAR_FORMAT }
        placeholderText="Select Date"
        selected={ toDate || maxDate }
        isClearable={ false }
        onChange={ handleToChange }
        minDate={ fromDate || minDate }
        maxDate={ maxDate }
        popperPlacement="bottom-end"
        usePortal
        dataTest="dateToPicker"
      />
    </Flex>
  );
};

export default DateFilter;
